"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("../RtcCommand");
const EventEmitter = require("wolfy87-eventemitter");
class NullCommandHub {
    constructor() {
        this.errorOccurred = new EventEmitter();
    }
    sendCommand(rtcCmd) { }
    sendCommands(rtcCmds) { }
    async sendCommandAsync(rtcCmd) { return RtcCommand_1.RtcCommand.InvalidRtcCommand; }
    async sendCommandsAsync(rtcCmds) { return []; }
    registerCommandHandler(category, handler) { }
    unRegisterCommandHandler(category) { }
    receiveCommand(rtcCmd) { }
    async receiveCommandAsync(rtcCmd) { }
}
exports.NullCommandHub = NullCommandHub;
exports.NullCommandHubSingleton = new NullCommandHub();
//# sourceMappingURL=NullCommandHub.js.map